import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useNavigationStore } from "@/stores/navigationStore";

// When a home route is reached with a `scrollToId` in router state — set by the
// nav tabs / back link while on a case-study detail page — scroll to that section
// once the layout has settled. Pairs with the cross-route handling in tab.tsx /
// mobile-nav.tsx and the detail hero's back link.
export function useScrollToSectionOnMount() {
  const location = useLocation();
  const navigate = useNavigate();
  const setIsNavigating = useNavigationStore((s) => s.setIsNavigating);

  useEffect(() => {
    const scrollToId = (location.state as { scrollToId?: string } | null)?.scrollToId;
    if (!scrollToId) return;

    // Consume the state so a refresh / back navigation doesn't re-scroll.
    navigate(".", { replace: true, state: null });

    // Pause the section tracker while we jump, then let pins/fonts settle before scrolling.
    setIsNavigating(true);
    const timer = setTimeout(() => {
      document
        .getElementById(scrollToId)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
      window.setTimeout(() => setIsNavigating(false), 1000);
    }, 350);

    return () => clearTimeout(timer);
    // Run once on mount with the initial router state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
